import { Card, CardProps } from '@chakra-ui/react';
import { PropsWithChildren } from 'react';

type Props = PropsWithChildren & CardProps;

export default function CardForm({ children, ...props }: Props) {
  return (
    <Card 
      mt="35px" 
      py="35px" 
      px="35px"
      borderRadius="20px"
      bgColor="white"
      boxShadow="0px 24px 56px -4px rgba(88, 92, 95, 0.10)"
      {...props}
      minH="full"
    >
      {children}
    </Card>
  )
}
